/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  FaqContainer,
  FaqGroup,
  FaqItem,
  FaqTrigger,
  FaqContentWrapper,
  FaqContentInner,
  SubQuestionTrigger,
} from './styles';
import arrow1 from 'src/assets/Arrow1.svg';
import styled from 'styled-components';

const faqData = [
  {
    id: 2,
    question: (
      <>
        <span style={{ fontSize: '24px', fontWeight: 'semibold', color: '#000', cursor: 'default' }}>
          Help and support
        </span>
      </>
    ),
  },
  {
    id: 1,
    question: 'Need Assistance?',
    answer: (
      <>
        <b>Need Assistance?</b>
        <br />
        <p className="uniqueClassName" style={{ fontSize: '9px', margin: 0 }}>
          Created by Piyush Katyal, last modified on June 28, 2024
        </p>
        <br />
        <b>Employee Self Service Portal - Assistance</b>
        <br />
        <p>
          We welcome your feedback and are here to assist you if you need support. Feel free to reach out to us via our
          support email. Your input is valuable to us.
        </p>
        <br />
        <b> E-mail Support</b>
        <p>
          We invite you to communicate with us via email at &nbsp;
          <a href="mailto:esssupport@prideglobal.com">esssupport@prideglobal.com</a>. Kindly include your Employee ID
          and Company Name in your correspondence. Rest assured, each email sent to the address is automatically
          transformed into a support ticket on our Employee Portal platform. Your cooperation is greatly appreciated.
        </p>
        <br />
        <b>Online Support</b>
        <p>
          As soon as you open the link of the Employee Portal, you can raise a ticket online by clicking on the Support
          tab. Once you click Support, you can raise a query by sending a mail to us.
        </p>
        <br />
        <img src="wa1.png" alt="wa1.png" />
        <br />
        <br />
        <b>Where can I update my address? </b>
        <br />
        <p>
          To update your address and/or phone number,send an email to &nbsp;
          <a href="mailto:esssupport@prideglobal.com">esssupport@prideglobal.com</a> .
        </p>
      </>
    ),
  },
  {
    id: 4,
    question: ' How do I reset my password?',
    answer: (
      <>
        <b>How do I reset my password?</b>
        <br />
        <p>On the login page, click the question mark icon in the password tab and follow the prompts.</p>
        <br />
        <b>Step 1: Selecting “Forgot Password”</b>
        <br />
        <p>
          Navigate to the “Sign In” page. Click on the “?” symbol that is placed on the right side of the “Password”
          field.
        </p>

        <img src="rp1.png" alt="rp1.png" />
        <br />
        <br />
        <b>Step 2: Enter Email Address</b>
        <br />
        <p>A “Reset Password Request” window will appear. Enter your registered email address and hit “Continue.”</p>
        <img src="rp2.png" alt="rp2.png" />
        <br />
        <br />
        <b>Step 3: Answer Security Questions</b>
        <br />
        <p>
          You will then be asked to answer the security questions you selected during the sign-up process. Enter your
          answers and hit “Continue.”
        </p>
        <img src="rp3.png" alt="rp3.png" />
        <br />
        <br />
        <b>Step 4: Reset Password Email</b>
        <br />
        <p>
          A “Reset Password” email will be sent to your registered email address. Click on the provided link in the body
          of the email.
        </p>
        <img src="rp4.png" alt="rp4.png" />
      </>
    ),
  },
  {
    id: 6,
    question: 'How can I view my benefits?',
    answer: (
      <>
        <b>How can I view my benefits?</b>
        <br />
        Left band {'>'} Benefits
        <br />
        <br />
        <b>Step 1: Click on Benefits option on the left slidebar.</b>
        <br />
        <img src="Benefits1.png" alt="Benefits1.png" />
        <br />
        <br />
        <b>
          Step 2: Active tab lists the benefits you are currently enrolled. Historic Enrollment lists the benefits you
          were previously enrolled.
        </b>
        <br />
        <img src="Benefits2.png" alt="Benefits2.png" />
      </>
    ),
  },
  {
    id: 601,
    question: 'Elect New Hire benefits for Internal Employee',
    answer: (
      <>
        <b>User Guide - Employee Portal New Hire Internal</b>
        <br />
        <p> Follow the steps outlined below to make your new hire elections. </p>
        <br />
        <img src="internal1.png" alt="internal1.png" />
        <br />
        <img src="internal2.png" alt="internal2.png" />
        <br />
        <img src="internal3.png" alt="internal3.png" />
        <br />
        <img src="internal4.png" alt="internal4.png" />
        <br />
        <img src="internal5.png" alt="internal5.png" />
        <br />
        <img src="internal6.png" alt="internal6.png" />
        <br />
        <img src="internal7.png" alt="internal7.png" />
        <br />
        <img src="internal8.png" alt="internal8.png" />
        <br />
        <img src="internal9.png" alt="internal9.png" />
        <br />
        <img src="internal10.png" alt="internal10.png" />
        <br />
        <img src="internal11.png" alt="internal11.png" />
        <br />
        <img src="internal12.png" alt="internal12.png" />
        <br />
        <img src="internal13.png" alt="internal13.png" />
        <br />
        <img src="internal14.png" alt="internal14.png" />
        <br />
        <img src="internal15.png" alt="internal15.png" />
        <br />
        <img src="internal16.png" alt="internal16.png" />
        <br />
        <img src="internal17.png" alt="internal17.png" />
        <br />
        <img src="internal18.png" alt="internal18.png" />
        <br />
        <img src="internal19.png" alt="internal19.png" />
        <br />
        <img src="internal20.png" alt="internal20.png" />
        <br />
        <img src="internal21.png" alt="internal21.png" />
        <br />
        <img src="internal22.png" alt="internal22.png" />
        <br />
      </>
    ),
  },
  {
    id: 602,
    question: 'Elect New Hire benefits for External Employee',
    answer: (
      <>
        <b>User Guide - Enable Employee Portal External New Hire</b>
        <br />
        <p> Follow the steps outlined below to make your new hire elections. </p>
        <br />
        <img src="external1.png" alt="external1.png" />
        <br />
        <img src="external2.png" alt="external2.png" />
        <br />
        <img src="external3.png" alt="external3.png" />
        <br />
        <img src="external4.png" alt="external4.png" />
        <br />
        <img src="external5.png" alt="external5.png" />
        <br />
        <img src="external6.png" alt="external6.png" />
        <br />
        <img src="external7.png" alt="external7.png" />
        <br />
        <img src="external8.png" alt="external8.png" />
        <br />
        <img src="external9.png" alt="external9.png" />
        <br />
        <img src="external10.png" alt="external10.png" />
        <br />
        <img src="external11.png" alt="external11.png" />
        <br />
        <img src="external12.png" alt="external12.png" />
        <br />
        <img src="external13.png" alt="external13.png" />
        <br />
        <img src="external14.png" alt="external14.png" />
        <br />
        <img src="external15.png" alt="external15.png" />
        <br />
        <img src="external16.png" alt="external16.png" />
        <br />
      </>
    ),
  },

  {
    id: 8,
    question: 'Will I be able to upload verification documents that support my qualified life event (QLE)?',
    answer: (
      <>
        <b>Will I be able to upload verification documents that support my qualified life event (QLE)?</b>
        <br />
        <p>
          {' '}
          Yes. You are able to upload your verification documents. Left band {'>'} Benefits {'>'} QLE {'>'} Choose event
          and upload documents.
        </p>
        <br />
        <b>Step 1: Select the Qualifying Life Events tab on the Benefits home page.</b>
        <br />
        <img src="upload1.png" alt="upload1.png" />
        <br />
        <br />
        <b>Step 2: Verify your address is correct as listed and select Next at the bottom of the screen.</b>
        <br />
        <img src="upload2.png" alt="upload2.png" />
        <br />
        <br />
        <b>
          Step 3: Verify your dependents listed or select Add New dependents if needed. If you do not need to add
          dependents, select Next at the bottom of the screen.
        </b>
        <br />
        <img src="upload3.png" alt="upload3.png" />
        <br />
        <b>
          Step 4: On the Qualified Life Events (QLE) and Other Election Updates, complete the following:
          <br />
          • Ensure the QLE option is selected. <br />
          • In the Life Event Field, click the drop down arrow, and select your QLE.
          <br />
          • In the Event Date field, enter the date your qualifying life event occurred. <br />
          • In the Description field, note the details of your qualifying life event, and advise the changes you want to
          make. Ex, drop your spouse, add a new spouse, add newborn, etc. <br />
          • Select Upload and follow the prompts to upload the required documents needed for verification
          <br />• Select Next.
        </b>
        <br />
        <b>Step 5 – Make the appropriate changes to your elections.</b>
        <br />
        <b>Step 6: Select Continue to Review when all changes have been made.</b>
      </>
    ),
  },
  {
    id: 9,
    question: ' Will I receive confirmation of the changes I made in the system?',
    answer: (
      <>
        <b>Will I be able to upload verification documents that support my qualified life event (QLE)?</b>
        <br />

        <p>
          After your elections are made, a Confirmation Statement will be generated and emailed to your registered email
          address.
        </p>
      </>
    ),
  },
  {
    id: 10,
    question: ' Where can I view my paystubs?',
    answer: (
      <>
        <b>Where can I view my paystubs?</b>
        <br />
        <p>{'Left Band > Pay History >Select the date range > Download the Paystub or export as PDF/Excel.'}</p>
        <br />
        <b>Step 1: Click on the Pay History Button on the left slidebar.</b>
        <br />
        <img src="ph1.png" alt="ph1.png" />
        <br />
        <br />
        <b>Step 2: Select the date filter and download.</b>
        <br />
        <img src="ph2.png" alt="ph2.png" />
        <br />
      </>
    ),
  },
  {
    id: 11,
    question: 'Will I be able to print out my W-2 and 1095-C?',
    answer: (
      <>
        <b>Will I be able to print out my W-2 and 1095-C?</b>
        <br />
        <p>Yes. You will be able to print the documents, as long as a printer is attached.</p>
        <br />
        <b>Step 1: Click on the Tax Forms options on the left slidebar.</b>
        <br />
        <img src="w21.png" alt="w21.png" />
        <br />
        <br />
        <b>Step 2: click on the download link.</b>
        <br />
        <img src="w22.png" alt="w22.png" />
        <br />
      </>
    ),
  },
  {
    id: 14,
    question: ' What other information will I be able to update in the system?',
    answer: (
      <>
        <b>What other information will I be able to update in the system?</b>
        <br />
        <p>You can update your personal information,dependent information and work location.</p>
        <p>
          To update your address and/or phone number,send an email to&nbsp;
          <a href="mailto:esssupport@prideglobal.com">esssupport@prideglobal.com</a>
        </p>
      </>
    ),
  },
];

const FontWrapper = styled.div`
  font-family: 'Biotif', sans-serif;
`;

const FixedWidthTrigger = styled(FaqTrigger)`
  width: 250px;
  position: relative;

  box-sizing: border-box;
`;

const HelpSupport: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [activeSubIndex, setActiveSubIndex] = useState<number | null>(null);

  const handleFaqTriggerClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
    setActiveSubIndex(null);
  };

  const handleSubFaqTriggerClick = (subIndex: number) => {
    setActiveSubIndex(activeSubIndex === subIndex ? null : subIndex);
  };

  return (
    <FaqContainer>
      <FaqGroup>
        {faqData.map((faq, index) => (
          <FaqItem key={faq.id}>
            <FaqTrigger
              isActive={activeIndex === index}
              onClick={() => handleFaqTriggerClick(index)}
              style={{ cursor: 'pointer', position: 'relative' }}
            >
              {/* Removed the condition for the arrow */}
              {faq.question}
            </FaqTrigger>
          </FaqItem>
        ))}
      </FaqGroup>
      <FaqContentWrapper>
        {activeIndex !== null && <FaqContentInner>{faqData[activeIndex].answer}</FaqContentInner>}
      </FaqContentWrapper>
    </FaqContainer>
  );
};

export default HelpSupport;
